import React from 'react';
import { styled } from '@compiled/react';
import StarFilledIcon from '@atlaskit/icon/glyph/star-filled';
import { ff } from '@atlassian/jira-feature-flagging';

export const StarredHeader = ({ label }: { label: string }) => (
	<ContentWrapper>
		<StarFilledIcon
			size="small"
			label={
				ff('a11y-jira-team.projects-directory-v3.enable-sorting-by-starred-column') ? label : ''
			}
		/>
	</ContentWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentWrapper = styled.div({
	display: 'flex',
	justifyContent: 'center',
});
